import { observer } from 'mobx-react'
import React, { ReactElement } from 'react'
import {
  Controller,
  FieldValues,
  Control,
  FieldPath,
  FieldErrors,
  RegisterOptions,
  FieldName,
} from 'react-hook-form'
import {
  ErrorMessage,
  FieldValuesFromFieldErrors,
} from '@hookform/error-message'
import { IBaseOption } from './selects/utils'
import { IAsyncSelect, ISelect } from './selects'

interface LFControllerProps<T extends FieldValues> {
  control: Control<T>
  inputName: FieldPath<T>
  children: ReactElement<ISelect<IBaseOption> | IAsyncSelect<IBaseOption>>
  errors?: FieldErrors<T>
  rules?: Pick<
    RegisterOptions<T>,
    | 'maxLength'
    | 'minLength'
    | 'validate'
    | 'required'
    | 'pattern'
    | 'min'
    | 'max'
  >
}

export const LFControllerWrapper = observer(
  <T extends FieldValues>({
    control,
    inputName,
    children,
    rules,
    errors,
  }: LFControllerProps<T>) => {
    if (!React.isValidElement(children)) return null

    const errorName = inputName as unknown as FieldName<
      FieldValuesFromFieldErrors<FieldErrors<T>>
    >

    return (
      <div>
        <Controller
          name={inputName}
          control={control}
          rules={rules}
          render={({ field: { onChange, value } }) =>
            React.cloneElement(children, { onChange, value })
          }
        />
        {errors && (
          <ErrorMessage
            errors={errors}
            name={errorName}
            render={({ message }) => (
              <p className="text-lg font-light text-negative-300">{message}</p>
            )}
          />
        )}
      </div>
    )
  }
)
